import React from 'react';
import { CssBaseline } from '@mui/material';
import { Box, ThemeProvider } from '@mui/material';
import { StyledEngineProvider, Theme } from '@mui/material';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

// import themeVariant, { themeVariantInterface } from "./themeSelector";

// interface ThemeWrapperProps {
//   children: React.ReactNode;
// }

interface MUIThemeWrapperProps {
	theme?: Theme;
	enableCssBaseline?: boolean;
	children: React.ReactNode;
}

const MUIThemeWrapper: React.FC<MUIThemeWrapperProps> = ({
	theme,
	enableCssBaseline = true,
	children
}) => {
	// const muiCache = useMemo(
	//   () =>
	//     createCache({
	//       key: 'mui',
	//       prepend: true,
	//     }),
	//   []
	// );

	const muiCache = createCache({
		key: 'mui',
		prepend: true
	});

	if (!theme) {
		return <>{children}</>;
	}

	return (
		<StyledEngineProvider injectFirst>
			<CacheProvider value={muiCache}>
				<ThemeProvider theme={theme}>
					{enableCssBaseline && <CssBaseline />}
					<Box bgcolor={'background.default'} /* marginTop={"4.6875rem"} */>
						{children}
					</Box>
				</ThemeProvider>
			</CacheProvider>
		</StyledEngineProvider>
	);
};

export default MUIThemeWrapper;
